<br>
<br><footer class="page-footer font-small dark bg-dark " style=" color: white;">

    <!-- Copyright -->
    <div class="footer-copyright text-center py-3">© 2020 Copyright:
      <h6> Vizsio</h6>
    </div>
    <!-- Copyright -->
  
  </footer>